import useThemeManager from '@/Theme/hooks/useThemeManager';
import {
  ComputerDesktopIcon,
  MoonIcon,
  SunIcon,
} from '@heroicons/react/24/solid';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';

const ThemeSelector = ({ classNameContainer = '' }) => {
  const { applyTheme, getSystemTheme } = useThemeManager();
  const [selectedTheme, setSelectedTheme] = useState(
    localStorage.getItem('theme')
  );

  const iconSize = 'w-5 h-5';

  useEffect(() => {
    const saved = localStorage.getItem('theme');
    const current = ['light', 'system', 'dark'].includes(saved)
      ? saved
      : 'system';

    setSelectedTheme(current);
    applyTheme(current === 'system' ? getSystemTheme() : current, current);
  }, []);

  const handleChange = (_, newTheme) => {
    if (!newTheme) return;
    setSelectedTheme(newTheme);
    applyTheme(newTheme === 'system' ? getSystemTheme() : newTheme, newTheme);
  };

  return (
    <ToggleButtonGroup
      value={selectedTheme}
      exclusive
      onChange={handleChange}
      sx={{
        mx: 2,
        borderRadius: '9999px',
        border: '1px solid #e0e0e0',
        overflow: 'hidden',
        '& .MuiToggleButton-root': {
          textTransform: 'none',
          padding: '6px 12px',
          border: 'none',
          gap: '6px',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
        },
      }}
    >
      <ToggleButton value="light">
        <SunIcon className={`${iconSize} text-yellow-500`} />
      </ToggleButton>
      <ToggleButton value="system">
        <ComputerDesktopIcon className={`${iconSize} text-blue-500`} />
      </ToggleButton>
      <ToggleButton value="dark">
        <MoonIcon className={`${iconSize} text-gray-300`} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ThemeSelector;
